import {ThreeDot} from "../../../../../components/three-dot/three-dot";
import {Message, MessageSections} from "../../../../../components/message/message";
import React from "react";
import {
    InWarehouseActionTypes,
    ReadyForShipmentActionTypes,
} from "../../../../../../management-pages/actions/action-types.enum";
import {OrderModel} from "../../../../../shared/models/order/order-item.model";
import {OrderListActionItem} from "../../styled";
import {
    BinLevel,
    CorridorLevel,
    DepotLevel,
    RackLevel,
    SectorLevel
} from "../../../../../../management-pages/orders/location-table/model/location-response.model";

export const RowActions = ({row, locationRow, onAction, onLocationRowAction, actions}: InWarehouseActionsProps) => {
    return (
        <div style={{width: '100%', display: 'flex', justifyContent: 'end'}}>
            {actions && actions.length &&
                <ThreeDot>
                    {actions.map(({id, icon, name}) =>
                        <OrderListActionItem onClick={() => {
                                if (locationRow && onLocationRowAction) {
                                    onLocationRowAction(locationRow, id as any)
                                } else if (onAction) {
                                    onAction(row as OrderModel, id)
                                }
                            }}
                            key={id}>
                            {icon}
                            <Message messageKey={name} sectionId={MessageSections.ORDERS}/>
                        </OrderListActionItem>)}
                </ThreeDot>
            }
        </div>
    )
}

interface InWarehouseActionsProps {
    actions: {id: string, name: string, icon: React.ReactElement}[];

    row?: OrderModel;
    onAction?: (row: OrderModel, action: string) => void,

    locationRow?: DepotLevel | SectorLevel | CorridorLevel | RackLevel | BinLevel;
    onLocationRowAction?: (row: DepotLevel | SectorLevel | CorridorLevel | RackLevel | BinLevel | undefined, action: InWarehouseActionTypes | ReadyForShipmentActionTypes) => void,
}